import { render, staticRenderFns } from "./purchasedItem.vue?vue&type=template&id=5c2999ca&"
import script from "./purchasedItem.vue?vue&type=script&lang=js&"
export * from "./purchasedItem.vue?vue&type=script&lang=js&"
import style0 from "./purchasedItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports